import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Locale, LocaleCode, LocaleList } from '@gelato-api-ui/core/i18n/locales.constant';
import { DeckRef } from '@gelato-api-ui/ui-kit/src/lib/deck/components/deck-ref/deck-ref';
import { DeckService } from '@gelato-api-ui/ui-kit/src/lib/deck/services';
import { DeckContentType } from '@gelato-api-ui/ui-kit/src/lib/deck/types';
import { DropdownRef } from '@gelato-api-ui/ui-kit/src/lib/dropdown/components/dropdown-ref/dropdown-ref';
import { DropdownService } from '@gelato-api-ui/ui-kit/src/lib/dropdown/services';
import { DropdownContentType } from '@gelato-api-ui/ui-kit/src/lib/dropdown/types';
import { Subject } from 'rxjs';

@Component({
  selector: 'gd-language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguagePickerComponent {
  @Input() currentLocaleCode: string;
  @Input() isMobile: boolean;
  @Output() changeLocaleCode = new EventEmitter<LocaleCode>();

  @ViewChild('origin') origin: ElementRef;
  @ViewChild('langListContent') langListContent: ElementRef;

  ngOnDestroy$ = new Subject();

  public languagesList = LocaleList;

  private dropdownRef: DropdownRef;
  private deckRef: DeckRef;

  constructor(private readonly dropdown: DropdownService, private readonly deck: DeckService) {}

  get currentLocale(): Locale {
    return this.languagesList.find(lang => lang.code === this.currentLocaleCode);
  }

  onOpenSwitcher(content: DropdownContentType, origin: HTMLElement | ElementRef): void {
    this.onCloseSwitcher();

    if (this.isMobile) {
      this.onOpenMobileSwitcher(content);
    } else {
      this.onOpenDesktopSwitcher(content, origin);
    }
  }

  onChangeLocaleCode(value: LocaleCode): void {
    this.changeLocaleCode.emit(value);
    this.onCloseSwitcher();
  }

  onCloseSwitcher() {
    if (this.dropdownRef) {
      this.dropdownRef.triggerCloseDropdown();
    }

    if (this.deckRef) {
      this.deckRef.triggerCloseDeck();
    }
  }

  onOpenMenu() {
    this.onOpenSwitcher(this.langListContent, this.origin);
  }

  private onOpenDesktopSwitcher(content: DropdownContentType, origin: HTMLElement | ElementRef): void {
    if (this.dropdownRef) {
      this.dropdownRef.close();
    }

    this.dropdownRef = this.dropdown.open({
      content,
      origin,
      width: 250,
      height: 'auto',
      position: 'end',
    });
  }

  private onOpenMobileSwitcher(content: DeckContentType): void {
    this.deckRef = this.deck.open({
      content,
      width: '100%',
      height: 'auto',
    });
  }
}
